// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3f_UD","container":"styles_container__8foDV","title":"styles_title__WPQbU","wrapper":"styles_wrapper__2-QYM","answer":"styles_answer__1nr9D"};